const removeDuplicateWhitespaces = str => str.replace(/\s+/g, ' ')

export default removeDuplicateWhitespaces
